import React, { Component } from 'react';
import Autocomplete from 'react-autocomplete';

export default class AnularEntregaProgramada extends Component {

  constructor(props) {
    super(props);
    this.state = {
      optionMotivo: '',
      comentario: '',
      colaboradorCaja: '',
      colaboradores: [],
      colaboradoresSeleccionados: [],
      validarCampo: false,
    };
    this.clickCancelar = this.clickCancelar.bind(this);
    this.clickAnularEntrega = this.clickAnularEntrega.bind(this);
    this.changeSearchOptionMotivo = this.changeSearchOptionMotivo.bind(this);
    this.onChangeComentarioInput = this.onChangeComentarioInput.bind(this);
    this.cerrarModalAnularEntregaProgramada = this.cerrarModalAnularEntregaProgramada.bind(this);
    this.traerColaboradores = this.traerColaboradores.bind(this);
    this.limpiarColaboradores = this.limpiarColaboradores.bind(this);
    this.limpiarInputs = this.limpiarInputs.bind(this);
  }
  componentDidMount() {
  }
  componentWillReceiveProps(prop) {
    this.setState({ colaboradores: prop.colaboradores });
  }
  onChangeComentarioInput(e) {
    this.setState({ comentario: e.target.value });
  }
  changeSearchOptionMotivo(e) {
    this.setState({ optionMotivo: e.target.value });
  }
  clickCancelar() {
    this.cerrarModalAnularEntregaProgramada();
  }
  clickAnularEntrega() {
    if (this.state.optionMotivo === '' ||
       this.state.comentario.length === 0) {
      this.setState({ validarCampo: true });
    } else {
      this.setState({ validarCampo: false });
      this.props.clickAnularEntrega(
        { codColaborador: this.state.colaboradoresSeleccionados.map(item => item.id),
          codMotivo: this.state.optionMotivo,
          observacion: this.state.comentario,
        });
    }
  }

  cerrarModalAnularEntregaProgramada() {
    this.props.cerrarModalAnularEntregaProgramada();
  }

  traerColaboradores(value) {
    this.props.traerColaboradores(value);
  }

  limpiarColaboradores() {
    this.props.limpiarColaboradores();
  }
  limpiarInputs(Rows) {


    this.setState({ validarCampo: false });
    this.setState({ optionMotivo: '', comentario: '', colaboradoresSeleccionados: [], colaboradorCaja: '' });


    if(Rows!==null){
      const varpersona = [
        { id: Rows.vendedor, apellido: Rows.asesorComercial, status:1 },
        { id: Rows.codUsuarioCrea, apellido: Rows.nomUsuarioCrea, status:1}
      ];
      this.setState({colaboradoresSeleccionados : varpersona});
    }




  }

  render() {
    return (
      <div>
        <div className='modal' id='rechazarEntregaLogistica' role='dialog' data-backdrop='static' style={{ display: this.props.muestraModalAnularEntregaProgramada }} >
          <div className='modal-dialog' role='document'>
            <button className='btn btn-sm btn-blue modal-close' data-dismiss='modal' onClick={this.cerrarModalAnularEntregaProgramada} >Cerrar ventana</button>
            <div className='modal-content'>
              <div className='modal-body'>
                <h2 className='modal-title'>Anular entrega programada</h2>
                <div className='form-group'>
                  <label className='labelInfo'>Motivo*
                  </label>
                  <div className='select'>
                    <select className='form-control' value={this.state.optionMotivo} onChange={this.changeSearchOptionMotivo} >
                      <option value=''>Motivo</option>
                      {
                        this.props.estadoGeneralMotivoRechazo.map(item =>
                          <option
                            key={item.id}
                            value={item.id}
                          >
                            {item.descripcion}
                          </option>
                      )}
                    </select>
                    <div className='select-control-icon'><i className='ion-arrow-down-b' /></div>
                  </div>
                  <span className='error' style={{ display: (this.state.optionMotivo === '' && this.state.validarCampo) ? 'block' : 'none' }}>Introduce Motivo</span>
                </div>
                <div className='form-group'>
                  <div className='form-group'>
                    <label className='labelInfo'>Ingresa tu comentario*</label>
                    <textarea
                      className='form-control' value={this.state.comentario} onChange={this.onChangeComentarioInput}
                      placeholder='Ingresa tus comentarios acá'
                    />
                    <span className='error' style={{ display: (this.state.comentario === '' && this.state.validarCampo) ? 'block' : 'none' }}>Introduce comentario</span>
                  </div>
                </div>
                <div className='pillSelct'>
                  <p className='labelInfo'>Notifica a un colaborador</p>
                  <div className='pillSelct-field'>
                  <Autocomplete
                      getItemValue={item => item.idUsuario.toString()}
                      items={this.state.colaboradores}
                      renderItem={(item, isHighlighted) =>
                        <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                          {`${item.apellidos} ${item.nombre}`}
                        </div>
                      }
                      onChange={(e) => {
                        if (e.target.value.length >= 2) {
                          this.traerColaboradores(e.target.value);
                        }
                        if (e.target.value.length === 0) {
                          this.limpiarColaboradores();
                        }
                        this.setState({ colaboradorCaja: e.target.value });
                      }}
                      value={this.state.colaboradorCaja}
                      autoHighlight={this.state.trueComplete}
                      onSelect={(key) => {
                        const tieneColaborador = this.state.colaboradoresSeleccionados.filter(({ id }) => id === key);

                        const name = this.state.colaboradores
                                      .filter(({ idUsuario }) =>
                                        idUsuario.toString() === key)[0].nombre;

                        const apellidos = this.state.colaboradores
                                      .filter(({ idUsuario }) =>
                                        idUsuario.toString() === key)[0].apellidos;
                        const varpersona = { id: key, apellido: `${apellidos} ${name}` };
                        if (tieneColaborador.length < 1) {
                          this.setState({
                            colaboradoresSeleccionados: [...this.state.colaboradoresSeleccionados, varpersona]
                          });
                        }
                        this.setState({colaboradorCaja: ''});
                        this.limpiarColaboradores();
                      }}
                        menuStyle={{
                        position: 'absolute',
                        left: '0',
                        top: '100%',
                        maxHeight: '350px',
                        overflow: 'auto',
                        border: '1px solid #cccccc',
                      }}
                      inputProps={{
                        className: 'form-control awesomplete pillSelct-input',
                      }}
                      wrapperStyle={{
                        position: 'relative',
                        zIndex: '10',
                      }}
                    />
                  </div>
                  <div className='pillSelct-pills'>
                    {
                            this.state.colaboradoresSeleccionados.map((item, i) =>
                              <label key={i} className='pill pill-cyan pillSelct-pills-item'>{item.apellido}

                              {item.status!==1?(
                                <button
                                  type='button'
                                  className='pillSelct-delete'
                                  onClick={() => this.setState({
                                    colaboradoresSeleccionados: this.state
                                                                  .colaboradoresSeleccionados
                                                                  .filter(({ id }) =>
                                                                  id !== item.id) })}
                                >
                                  <i className='icon ion-close pill-close' />
                                        </button>
                              ):(
                                <button
                                  type='button'
                                  className='pillSelct-delete'
                                >
                                      </button>
                              )}


                              </label>
                    )}
                  </div>
                </div>
                <div className='modal-actions'>
                  <button className='btn btn-default pull-left' data-dismiss='modal' onClick={this.clickCancelar} >Cancelar</button>
                  <button className='btn btn-danger pull-right' data-dismiss='modal' onClick={this.clickAnularEntrega} >Anular entrega</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/FichaEntrega/AnularEntregaProgramada.js